/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { IConfigurationModel } from "@nf/common";
import React from "react";

import LayoutSection from "components/LayoutSection";
import InternalImage from "components/InternalImage";
import AppFooterDesktop from "components/AppFooter/AppFooterDesktop";

import styles from "./LoginLayout.module.scss";

interface LoginLayoutProps {
  children: React.ReactNode;
  config: IConfigurationModel;
}

const LoginLayout = ({ children, config }: LoginLayoutProps) => {
  return (
    <div className={styles.container}>
      <LayoutSection className={styles.section}>
        <div className={styles.imageContainer}>
          <InternalImage imageId="login" className={styles.image} alt="" />
        </div>
        <div className={styles.content}>{children}</div>
      </LayoutSection>

      <AppFooterDesktop configuration={config} />
    </div>
  );
};

export default LoginLayout;
